import ErrorMessage from './ErrorMessage';
import AlertError from './AlertError';
import { apiWithToast, getToastMsg, getCustomToast } from './Toast';
// import { apiWithToast, getToast, } from './Toast';

export { AlertError, ErrorMessage, apiWithToast, getToastMsg, getCustomToast };
// export { getToast, AlertError, ErrorMessage, apiWithToast, };



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/index.js